import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../Header/Header';

const Instructions = () => {
  

  const [showMore, setShowMore] = useState(false);
  const [understood, setUnderstood] = useState(false);

  const toggleShowMore = () => {
    setShowMore(prevState => !prevState);
  };

  const handleCheckboxChange = () => {
    setUnderstood(!understood);
  };

  return (<>
    <Container className='py-5 border round my-3' style ={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', borderRadius: '9px'}}>
        
      <h2 className = 'text-center' style ={{color: '#123fae'}}>IMPORTANT INSTRUCTIONS</h2>

      <h5 className = 'text-center' style ={{color: '#255825'}}>Before filling the Registration cum Admission form, students are advised to follow the instructions given below </h5>

      <div className="instructions-list" >
        <ol>
          
          <li>Read all the instructions given on the admission portal and in this brochure carefully before filling the admission form.</li>
          <li>While filling up the form please make sure of spellings of your name, name of your father. In case of spelling mistakes, the spelling mistakes will not be entertained later on and the same will be printed on your admit card as well as final certificate. So, check these properly before submitting the form.</li>
          <li>The students are advised to provide the correct postal address/correspondence address as well as their own operational mobile number and Email ID as all the information related to their certificate course will be sent on their registered Mobile Number and Email ID. The CDOE or HKCL will not be responsible for non-receipt of SMS due to activation of DND services in the student’s Mobile or non-supply of correct mobile number.
             {/* {!showMore && (
            <span style={{ cursor: 'pointer', color: 'blue' }} onClick={toggleShowMore}>
            &nbsp; Read More...
            </span>
          )} */}
          </li>
          {/* {showMore && ( */}
            <>
              <li>The certificate course once chosen by the student will not be changed in any circumstances. </li>
              <li>The Registration fee as well as full course fee, once paid is neither refundable nor adjustable for any other certificate course.</li>
              <li>No fee shall be accepted in the form of a money order or cheque. However, the candidates can deposit the fee by online mode of payment.</li>
              <li>Admission on certificate courses will also be offered to foreign students. </li>
              <li>The students are advised to visit the Website of Centre for Distance and Online Education regularly for any update related to the course.</li>
              <li>Fill all the information asked in the Online Application form carefully. In case of any doubt or query, either read the prospectus or email at gjuskillcourses@hkcl.in.</li>
              <li>Students are advised to contact at the given contact details, in case of any issue throughout the filling of application form/ fee payment or course duration.</li>
              <li>Students will be given the Learner code and password after 3-7 working days after final submission of application form and payment of requisite course fee. </li>
          
              <li>After the declaration of the result, Marksheet/Certificate of candidates will be sent by Registered Post.</li>
              <li>CDOE/HKCL will send notifications related to courses in future as text 
              message/WhatsApp message on the given mobile number as well as on the given Email Id.</li>
            </>
          {/* )} */}
        </ol>
      </div>
      {/* Checkbox and button for consent */}
      <div className="checkbox-and-button">
        <label>
          <input type="checkbox" checked={understood} onChange={handleCheckboxChange} />
          <span className='px-2' style ={{color: '#413c58'}}> <b>I have read and understood the instructions mentioned above and I'm accepting there to give my consent for the same.</b></span>
        </label>
      </div>
      {/* Proceed button */}
      {understood && (
        <div className="text-center pt-2">
          <Link to="/registration">
            <button className="bg-success" style={{ backgroundColor: 'green', color: 'white', padding: '5px 10px', fontSize: '14px' }} onClick={() => console.log("Proceed button clicked")}>Accept and Proceed</button>
          </Link>

          
        </div>

        
      )}
    </Container></>
  );
};

export default Instructions;
